import React from "react";
import { Grid } from "semantic-ui-react";
import AppForm from "../../../components/form/Form";
import { BusinessRegistrationModel, BusinessRegistrationContactInfoStepFormModel } from "../types";
import BusinessRegistrationActions from "../BusinessRegistrationActions";
import { FULLNAME_REGEXP, PASSWORD_STRENGTH_REGEXP } from "../../../app/helpers/regexp";
import { useTranslation } from "react-i18next";
import { useAppForm } from "../../../components/form/useForm";
import { NonAuthRoutes } from "../../../app/auth/routes";
import { Link } from "react-router-dom";

interface Props {
  model: Partial<BusinessRegistrationModel>;
  onSubmit: (m: BusinessRegistrationContactInfoStepFormModel) => any;
  isDisabled: boolean;
}

const BusinessRegistrationContactInfoStep: React.FC<Props> = ({ model, onSubmit, isDisabled }) => {
  const { t } = useTranslation();
  const formHook = useAppForm({ defaultValues: { ...defaultValues, ...model, repeatedPassword: "" } });

  return (
    <>
      <p>{t("auth.steps.business.contactInfo.text")}</p>
      <AppForm formHook={formHook} onSubmit={onSubmit} isDisabled={isDisabled}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <AppForm.Group name="contactInfo.fullName" label="auth.steps.business.contactInfo.fullName">
                <AppForm.Input
                  name="contactInfo.fullName"
                  placeholder="auth.steps.business.contactInfo.fullName_placeholder"
                  rules={{
                    required: true,
                    pattern: {
                      value: FULLNAME_REGEXP,
                      message: "shadowing.errors.fullname",
                    },
                  }}
                />
              </AppForm.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <AppForm.Group name="contactInfo.jobTitle" label="auth.steps.business.contactInfo.jobTitle">
                <AppForm.Input
                  name="contactInfo.jobTitle"
                  placeholder="auth.steps.business.contactInfo.jobTitle_placeholder"
                  rules={{ required: true }}
                />
              </AppForm.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>
              <AppForm.Group name="contactInfo.email" label="auth.steps.business.contactInfo.email">
                <AppForm.Email
                  name="contactInfo.email"
                  placeholder="auth.steps.business.email_placeholder"
                  rules={{ required: true }}
                />
              </AppForm.Group>
            </Grid.Column>
            <Grid.Column width={8}>
              <AppForm.Group name="contactInfo.phoneNumber" label="auth.steps.business.contactInfo.phone">
                <AppForm.Phone name="contactInfo.phoneNumber" rules={{ required: true }} />
              </AppForm.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <AppForm.Group name="password" label="auth.steps.business.password">
                <AppForm.Password
                  name="password"
                  rules={{
                    required: true,
                    pattern: {
                      value: PASSWORD_STRENGTH_REGEXP,
                      message: "auth.steps.password.validation.password_strenght",
                    },
                  }}
                />
              </AppForm.Group>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16}>
              <AppForm.Group name="repeatedPassword" label="auth.steps.business.repeatedPassword">
                <AppForm.Password
                  name="repeatedPassword"
                  rules={{
                    required: true,
                    validate: (v) =>
                      v !== formHook.getValues("password") ? "auth.steps.password.validation.password_match" : true,
                  }}
                />
              </AppForm.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <AppForm.Group name="privacyPolicy">
                <AppForm.Checkbox name="privacyPolicy" label="Sutinku su" rules={{ required: true }} />{" "}
                <Link to={NonAuthRoutes.privacyPolicy} target="_blank" rel="noopener noreferrer">
                  {t("common.privacy_policy")}
                </Link>
              </AppForm.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
      <BusinessRegistrationActions onSubmit={formHook.handleSubmit(onSubmit)} />
    </>
  );
};

export const defaultValues: BusinessRegistrationContactInfoStepFormModel = {
  contactInfo: {
    fullName: "",
    email: "",
    phoneNumber: "",
    jobTitle: "",
  },
  password: "",
};

export default BusinessRegistrationContactInfoStep;
